<template>
    <div>
        <Dialog :show-close-button="true" :show="show"
                :has-backdrop="true" @close="$emit('close')" width="600px">
            <div class="share-dialog-container">
                <h4>Preset teilen</h4>
                <p>Jeder mit dem Link kann auf das Preset zugreifen.</p>
                <InputDetail label="Shareable Link" :value="link" icon="icon-clipboard"
                             icon-size="24px" @click="copyLink" icon-border></InputDetail>
                <div>
                    <Checkbox @change="saveLink" id="link-checkbox" title="Link ist aktiv" v-model="active"></Checkbox>
                    <unicon name="info-circle" fill="#A0A0A0" style="position:relative; top:6px; left:-15px;" v-tooltip.right="infoText"></unicon>
                    <div v-if="loading" class="loaderContainer" :style="{width: loaderSize,display:'inline-block'}">
                        <svg class="spinner" viewBox="0 0 50 50"
                             :style="{width: loaderSize, height:loaderSize, margin: margin}">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

                <!--<div style="margin-top: 20px;display: flex; flex-direction: row; align-items: center">
                    <AdaButton :loading="loading" type="blue" title="BESTÄTIGEN" @click="saveLink"></AdaButton>
                    <div style="margin-left: 20px">{{message}}</div>
                </div>-->
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "./Dialog";
    import InputDetail from "../inputs/InputDetail";
    import Checkbox from "../inputs/Checkbox";
    // import AdaButton from "../buttons/AdaButton";

    export default {
        name: "ShareDialog",
        components: {
            Dialog,
            InputDetail,
            Checkbox,
        },
        data: function () {
            return {
                active: false,
                //  message: '',
                loading: false,
                infoText: "Pro Preset wird ein Link generiert – Über dieses Kontrollkästchen steuert der Versender, ob der Link für die Empfänger abrufbar ist. Aktive Links werden aus Sicherheitgründen nach 30 Tagen deaktiviert und können an dieser Stelle wieder aktiviert werden."
            }
        },
        props: {
            show: Boolean,
            loaderSize: {
                type: String,
                default: '20px'
            }
        },
        computed: {
            link() {
                return location.href + '?key=' + this.$store.state.presets.currentPreset.extern_link_hash;
            },
            margin() {
                let size = parseInt(this.loaderSize) / 2;
                return `-${size} 0 0 -${size}`
            }
        },
        mounted() {
            console.log('mounted')
            this.active = this.$store.state.presets.currentPreset.extern_link_is_active === 1;
        },
        methods: {
            saveLink() {
                this.loading = true;
                this.$store.dispatch('presets/updateLinkState',
                    {
                        id: this.$route.params.id,
                        active: this.active
                    }
                ).then(() => {
                    this.loading = false;
                    // this.$emit('close');
                }).catch(e => console.error(e));
            },
            copyLink() {
                this.$clipboard(this.link);
                // this.message = 'Der Link wurde in die Zwischenablage kopiert.';
                this.$noty.info('Der Link wurde in die Zwischenablage kopiert.');
            }
        },
        watch: {
            show() {
                if (this.show) {
                    this.active = this.$store.state.presets.currentPreset.extern_link_is_active === 1 || this.$store.state.presets.currentPreset.extern_link_is_active === true;

                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .share-dialog-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .share-dialog-container > * {
        margin-bottom: 10px;
    }

    :deep( .checkbox-containe)r {
        margin-left: 0;
    }

    :deep( .modal-container) {
        display: flex;
        flex-flow: column;

        .title {
            margin-bottom: 20px;
        }
    }


    .loaderContainer {
        margin-left: 10px;
        position: relative;

        .spinner {
            animation: rotate 2s linear infinite;
            z-index: 2;
            position: absolute;

            top: 50%;
            left: 50%;


            & .path {
                stroke: #d0d4da;
                color: #41484f;
                stroke-linecap: round;
                animation: dash 1.5s ease-in-out infinite;
            }

        }
    }


    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }

</style>